import React from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import topback from "../images/beetitle.png";
import PTAIMG from "../images/PTA2024-25.jpg";

function PTA(){
    return(
        <>
        <Header />
  <section class="content-section title-top" style={{ backgroundImage: `url(${topback})` }}>
  <div class="pattern-overlay">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 title-heading">
        <h2>PTA</h2>  
	   </div>
      </div>
    </div>
  </div>
</section>
<div className="container mt-5 pb-5">
    <div className="img-main">
        <img src={PTAIMG} />
        <p>Principal Dr Sunita Goyal with PTA Office Bearers 2024-25</p>
    </div>
</div>
        <Footer />
        </>
    );
}

export default PTA;